/**
 * Typescript often requires "unnecessary" nullchecks because it doesn't
 * fully understand the runtime behavior.
 *
 * This function allows you to assert that, within a specific scope, a
 * value is *not* null or undefined.
 *
 * Usage:
 * ```
 * function reactComponent() {
 *   const ref = useRef<HTMLVideoElement | null>();
 *
 *   onPlay = () => {
 *     // FAIL: ref.current might be null.
 *     ref.current.play();
 *
 *     // SUCCESS: ref.current is now known to exist.
 *     assertExists(ref.current);
 *     ref.current.play();
 *   };
 *
 *   return <video src="..." onPlay={onPlay} />;
 * ```
 */

export function assertExists<T>(arg: T | null | undefined): asserts arg is T {
  if (arg === null || arg === undefined) {
    throw new Error(
      `RuntimeTypeViolation: Expected a value to exist, but got '${String(
        arg,
      )}'.`,
    );
  }
}
